import {DxTreeListItemDataProvider} from "../../../dx-lists/domain/tree-list/dx-tree-list-item-data-provider";
import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";
import {DxToolbarActionResolver} from "../../../dx-lists/domain/list/dx-toolbar-action-resolver";
import {DxListToolbarAction} from "../../../dx-lists/domain/ui-options/list/toolbar/dx-list-toolbar-action";
import {PitFilteringAttribute} from "./pit-filtering-attribute";
import {PitFilterTreeNodeType} from "./pit-filter-tree-node-type";


/**
 * Узел дерева филтров.
 * Идея такова:
 *
 * 1. У нас есть несколько типов сущностей, которые нужно отображать в виде реестра (таблицы).
 *    Классический подход заключается в том, что "Реестр" является отдельным документом, к которому на уровне БД
 *    привязаны, например, задачи, мероприятия, планы и тд. Таким образом узлами дерва являются документы-реестры.
 *    При выборе узла в дереве по его документу подтягиваются данные в таблицу.
 *
 * 2. Такак-как такая завяка в БД мягко говоря гемор, то можно попробовать реализовать более универсальный подход.
 *    Пусть дерево будет не дервом документов, дервом объектов-фильров. То есть ноды "фильтрующего" дерева это:
 *
 *    2.1. Группируюшие папки
 *    2.2. Объекты-фильтры, содержащие некие метаданные о том как фильтрануть множество сущностей определнного типа,
 *         чтобы получить нужное подмножество (реестр).
 *
 * 3. Данный класс по сути декларирует лишь то что, по-сути, необходимо для отрисовки дерева.
 *    Как включить сюда метаданные для фильтрации конкртеного типа сущностей надо подумать.
 */
@jsonObject
export class PitFilterTreeNode implements DxTreeListItemDataProvider, DxToolbarActionResolver {
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _id: number;

  @jsonMember({name: "parentId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _parentId: number;

  // TODO: Идентификатор дерева (Сделано под показ)
  @jsonMember({name: "treeId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _treeId: number;

  @jsonMember({name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _ord: number;

  @jsonMember({name: "ident", constructor: String, emitDefaultValue: false, isRequired: false })
  private _ident: string;

  // TODO: В оригинале было title. name - под показ
  @jsonMember({name: "name", constructor: String, emitDefaultValue: false, isRequired: false })
  private _title: string;

  /*@jsonMember({name: "type", constructor: String, emitDefaultValue: false, isRequired: false})
  private _type: string;*/

  // TODO: Объект с данными о типе узла (Сделано под показ)
  @jsonMember({name: "type", constructor: PitFilterTreeNodeType, emitDefaultValue: false, isRequired: false})
  private _typeObj: PitFilterTreeNodeType;

  @jsonMember({name: "description", constructor: String, emitDefaultValue: false, isRequired: false })
  private _description: string;

  // TODO: захардкоденная JSON-строка с фильтром по столбцам грида (Сделано под показ)
  @jsonMember({name: "sqlFilter", constructor: String, emitDefaultValue: false, isRequired: false })
  private _sqlFilter: string;

  /**
   * @deprecated По факту нигде не используется. И не понятно зачем был нужен.
   */
  @jsonArrayMember(PitFilteringAttribute, {name: "attributes", emitDefaultValue: false, isRequired: false })
  private _attributes: PitFilteringAttribute[];


  public getItemId(): number {
    return this._id;
  }

  public getParentItemId(): number {
    return this._parentId;
  }

  setParentItemId(value: number): void {
    this._parentId = value;
  }

  public getItemType(): string {
    return this._typeObj.id === 1 ? 'FOLDER' : 'FILTER';
  }

  public setItemType(value: string): void {
    //this._type = value;
  }

  public getItemOrd(): number {
    return this._ord;
  }

  public getItemTitle(): string {
    return this._title;
  }

  public getItemIdent(): string {
    return this._ident;
  }

  public getItemIcon(): string {
    return "";
  }

  public getItemDescription(): string {
    return this._description;
  }

  public getItemSearchString(): string {
    return "";
  }

  public canExecuteToolbarAction(action: DxListToolbarAction): boolean {
    return true;
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get parentId(): number {
    return this._parentId;
  }

  set parentId(value: number) {
    this._parentId = value;
  }

  get ord(): number {
    return this._ord;
  }

  set ord(value: number) {
    this._ord = value;
  }

  get ident(): string {
    return this._ident;
  }

  set ident(value: string) {
    this._ident = value;
  }

  get title(): string {
    return this._title;
  }

  set title(value: string) {
    this._title = value;
  }

  get type(): string {
    return /*this._type*/ this._typeObj.id === 1 ? 'FOLDER' : 'FILTER';
  }

  set type(value: string) {
    //this._type = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get attributes(): PitFilteringAttribute[] {
    return this._attributes;
  }

  set attributes(value: PitFilteringAttribute[]) {
    this._attributes = value;
  }

  get treeId(): number {
    return this._treeId;
  }

  set treeId(value: number) {
    this._treeId = value;
  }

  get typeObj(): PitFilterTreeNodeType {
    return this._typeObj;
  }

  set typeObj(value: PitFilterTreeNodeType) {
    this._typeObj = value;
  }

  get sqlFilter(): string {
    return this._sqlFilter;
  }

  set sqlFilter(value: string) {
    this._sqlFilter = value;
  }
}
